class TestimonialSlider {
    constructor(element, options) {
        this.element = document.querySelector(element);
        this.activeSlideIndex = 0;
        this.previousSlideIndex = 0;
        this.slides = document.querySelector(element).querySelectorAll(".testimonialItem");
        this.eventTable = [];
        this.prevButton = document.querySelector(options?.prev) || null;
        this.nextButton = document.querySelector(options?.next) || null;
        this.device = this.getDevice();
        this.transitionEndEvents = {
            'transition': 'transitionend',
            'OTransition': 'oTransitionEnd',
            'MozTransition': 'transitionend',
            'WebkitTransition': 'webkitTransitionEnd'
        };
        this.init();
    }

    sliderTransitionEnd() {
        for (let t in this.transitionEndEvents) {
            if (this.element.style[t] !== undefined) {
                return this.transitionEndEvents[t];
            }
        }
    }

    getDevice() {
        return this.device;
    }

    handleDeviceChange(e) {
        const devices = {
            "(max-width: 1000px)": {
                device: "tablet"
            },
            "(max-width: 500px)": {
                device: "mobile"
            }
        }

        if (e.matches) {
            this.device = devices[e.media].device;
        } else if (e.matches) {
            this.device = devices[e.media].device;
        } else {
            this.device = "desktop";
        }
    }

    getMediaQueryList() {
        const tablet = window.matchMedia("(max-width: 1000px)");
        const mobile = window.matchMedia("(max-width: 500px)");
        return [tablet, mobile];
    }

    init() {
        this.getMediaQueryList().forEach(mq => {
            this.handleDeviceChange(mq);
            mq.addEventListener("change", this.handleDeviceChange.bind(this))
        });
        this.element.querySelectorAll(".testimonialItem").forEach((slide, idx) => {
            if (idx === 0) {
                slide.classList.add("active");
            }
            slide.dataset.index = idx;
        });

        if (this.prevButton) {
            this.prevButton.classList.add("disabled");
            this.prevButton.addEventListener("click", this.prev.bind(this));
        }

        if (this.nextButton) {
            this.nextButton.addEventListener("click", this.next.bind(this));
        }
    }

    getActiveSlide() {
        return this.element.querySelector(".testimonialItem.active");
    }

    prev() {
        const newActiveIndex = this.activeSlideIndex - 1;
        this.previousSlideIndex = this.activeSlideIndex;
        this.activeSlideIndex = newActiveIndex;
        this.transitionSlideBackwards();
        this.slides[this.previousSlideIndex].classList.remove("active");
        this.slides[this.activeSlideIndex].classList.add("active");
        this.setNavigationStates();
        this.fireEvent("slidechanged");
    }

    next() {
        const newActiveIndex = this.activeSlideIndex + 1;
        if (newActiveIndex > (this.slides.length - 1) / 2) return;
        this.previousSlideIndex = this.activeSlideIndex;
        this.activeSlideIndex = newActiveIndex;
        this.transitionSlideForward();
        this.slides[this.previousSlideIndex].classList.remove("active");
        this.slides[this.activeSlideIndex].classList.add("active");
        this.setNavigationStates();
        this.fireEvent("slidechanged");
    }

    setNavigationStates() {
        if ((this.activeSlideIndex + 1) > (this.slides.length - 1) / 2) {
            this.nextButton.classList.add("disabled");
        } else {
            this.nextButton.classList.remove("disabled");
        }

        if (this.activeSlideIndex === 0) {
            this.prevButton.classList.add("disabled");
        } else {
            this.prevButton.classList.remove("disabled");
        }
    }


    transitionSlideBackwards() {
        const activeIndexCount = (this.activeSlideIndex) < 0 ? 0 : this.activeSlideIndex;
        const device = this.getDevice();
        const activeSlideWidth = this.getActiveSlide().getBoundingClientRect().width;
        if (device === "tablet" || device === "mobile") {
            this.element.style.transform = `translate3d(-${this.activeSlideIndex * (activeSlideWidth + 33)}px, 0, 0)`;
        } else {
            this.element.style.transform = `translate3d(-${193 * activeIndexCount}px, 0, 0)`;
        }
    }

    transitionSlideForward() {
        const device = this.getDevice();
        const activeSlideWidth = this.getActiveSlide().getBoundingClientRect().width;
        if (device === "tablet" || device === "mobile") {
            this.element.style.transform = `translate3d(-${this.activeSlideIndex * (activeSlideWidth + 33)}px, 0, 0)`;
        } else {
            this.element.style.transform = `translate3d(-${this.activeSlideIndex * 193}px, 0, 0)`;
        }
    }

    on(eventName, callback) {
        this.eventTable.push({
            name: eventName,
            callback: callback
        })
    }

    fireEvent(eventName) {
        const events = this.eventTable.filter(event => {
            return event.name === eventName
        });

        events?.forEach(event => {
            event.callback();
        });
    }
}